import React from "react";
import MetaTags from "./components/MetaTags";
import { AppBarFour } from "./components/AppBar";
import { Container, Row, Col } from "react-bootstrap";
import { PiMapPinSimpleAreaBold } from "react-icons/pi";
import { BiPhoneCall } from "react-icons/bi";
import { MdOutlineAlternateEmail } from "react-icons/md";
import Mark from "./components/Mark";
const ContactUs = () => {
  return (
    <div className="overflow-hidden">
      <MetaTags
        title="Contact Us - P.I. PAVITHRA CRACKERS - Wholesale & Retail Crackers"
        type="website"
        siteName="pavithracrackers.com"
        url="https://pavithracrackers.com/contactus"
        keywords="Contact Us | P.I. PAVITHRA Crackers | Sivakasi Crackers"
        description="Contact P.I. PAVITHRA CRACKERS for wholesale and retail crackers in Sivakasi"
        revisitAfter="10 Days"
      />
      <AppBarFour />
      <img
        src={require("../assets/images/banner/banner_onefour.jpg")}
        className="img-fluid w-100"
        alt="product name"
      />
      <Container className="padding">
        <Row>
          <Col xs={12} sm={12} md={12} lg={12} className="py-3">
            <h1 className="bold black text-center"> Contact Us</h1>
          </Col>
          <Col lg="4" md="12" className="py-3">
            <a href="https://www.google.com/maps/search/?api=1&query=5%2F288%2F1A%2C+Mariyamman+Nagar%2C+Naranapuram%2C+Sivakasi" target="_blank" rel="noreferrer" style={{ textDecoration: 'none', color: 'inherit' }}>
              <div className="box" style={{ cursor: 'pointer' }}>
                <div className="box-icon">
                  <PiMapPinSimpleAreaBold size={40} color={"#000"} />
                </div>
                <div className="bold"> 5/288/1A, Mariyamman Nagar, Naranapuram, Sivakasi</div>
              </div>
            </a>
          </Col>
          <Col lg="4" className="py-3">
            <div className="box">
              <div className="box-icon">
                <BiPhoneCall size={40} color={"#000"} />
              </div>
              <div>
                <li className="bold"><a href="tel:+919003800584" style={{ textDecoration: 'none', color: 'inherit' }}>+91 900 3800 584</a></li>
                <li className="bold"><a href="tel:+918098086212" style={{ textDecoration: 'none', color: 'inherit' }}>+91 80980 86212</a></li>
              </div>
            </div>
          </Col>
          <Col lg="4" className="py-3">
            <div className="box">
              <div className="box-icon">
                <MdOutlineAlternateEmail size={40} color={"#000"} />
              </div>
              <div className="pb-4">
                <div className="bold"> pipavithracrackers@gmail.com</div>
              </div>
            </div>
          </Col>

          <Col lg="12" md="12" xs="12" className="py-5">
            <>
              <iframe
                src="https://maps.google.com/maps?q=5/288/1A,+Mariyamman+Nagar,+Naranapuram,+Sivakasi&t=&z=15&ie=UTF8&iwloc=&output=embed"
                width="100%"
                height="600"
                style={{ border: 0, borderRadius: "12px", boxShadow: "0 8px 25px rgba(0,0,0,0.1)" }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="strict-origin-when-cross-origin"
                title="Google Maps Embed of P.I. PAVITHRA CRACKERS, Sivakasi"
              ></iframe>
            </>
          </Col>
        </Row>
      </Container>

      <>
        <Mark />
      </>
    </div>
  );
};

export default ContactUs;
